import { LocalDate } from '@js-joda/core';
import { DateTime, Effect } from 'effect';

/**
 * Converts Effect DateTime.Zoned to JS-Joda LocalDate
 */
export const toJodaLocalDate = (zoned: DateTime.Zoned): LocalDate =>
  LocalDate.of(
    DateTime.getPart(zoned, 'year'),
    DateTime.getPart(zoned, 'month'),
    DateTime.getPart(zoned, 'day')
  );

/**
 * Effect that gets the current LocalDate in the configured timezone.
 * Uses DateTime.CurrentTimeZone from the Effect layer.
 */
export const getCurrentLocalDate: Effect.Effect<LocalDate, never, DateTime.CurrentTimeZone> =
  DateTime.nowInCurrentZone.pipe(Effect.map(toJodaLocalDate));
